import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ZoomService {
  private zoomSubject = new BehaviorSubject<number>(5);
  public zoom$ = this.zoomSubject.asObservable();
  public static readonly MIN_ZOOM = 2;
  public static readonly MAX_ZOOM = 8;
  public static readonly ZOOM_STEP = 0.1;

  setZoom(value: number) {
    const clampedValue = Math.max(ZoomService.MIN_ZOOM, Math.min(ZoomService.MAX_ZOOM, value));
    this.zoomSubject.next(clampedValue);
  }

  incrementZoom() {
    this.setZoom(this.getCurrentZoom() + ZoomService.ZOOM_STEP);
  }

  decrementZoom() {
    this.setZoom(this.getCurrentZoom() - ZoomService.ZOOM_STEP);
  }

  getCurrentZoom(): number {
    return this.zoomSubject.value;
  }
}